<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{$t('_TRAVEL_AGENT.TITLE_DEACTIVE')}}</span>
    </page-header>
    <left-menu />
    <div class="main-content right-page-content" id="list-agent-deactive">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="content-wrapper">
        <div class="card-item">
          <div class="card-item-content small-padding">
            <v-row no-gutters align="center">
              <v-col cols="7">
                <input-text
                  v-model="paging.name"
                  @input="search"
                  :placeholder="$t('_TRAVEL_AGENT.SEARCH_PLACEHOLDER')"
                  class="main-input-text"
                />
              </v-col>
              <v-col cols="5" class="text-right"></v-col>
            </v-row>
          </div>
          <v-data-table
            :headers="headers"
            :items="data"
            :items-per-page="15"
            disable-sort
            hide-default-footer
            item-key="id"
            class="main-table"
          >
            <template slot="no-data">
              <span>{{$t("HAS_NO_DATA")}}</span>
            </template>
            <template v-slot:item.name="{ item }">
              <div v-if="item.local" class="d-flex flex-column">
                <span style="font-weight: 500;">{{item.local.name}}</span>
                <v-row no-gutters align="start" class="pt-1">
                  <v-col cols="auto">
                    <v-icon small color="#173d8f">room</v-icon>
                  </v-col>
                  <v-col class="pl-2">
                    <span class="text-address">{{item.local.address}}</span>
                  </v-col>
                </v-row>
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <span v-if="item.local">{{item.local.type}}</span>
            </template>
            <template v-slot:item.level="{ item }">
              <span class="text-level">{{$t("_TRAVEL_AGENT.LEVEL_" + item.level)}}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <button
                @click="active(item)"
                class="main-btn btn-pmirary"
              >{{$t('_TRAVEL_AGENT.ACTIVE')}}</button>
              <v-menu left offset-y class="ml-3" max-height="100px">
                <template v-slot:activator="{ on, value }">
                  <button v-on="on" class="no-focus-border">
                    <v-icon color="#173d8f" :class="{ 'flip-180': value }">arrow_drop_down</v-icon>
                  </button>
                </template>
                <v-card class="card-note">{{item.note}}</v-card>
              </v-menu>
            </template>
          </v-data-table>
          <paging v-if="loading === false && paging && paging.total" :paging.sync="paging" @changePage="changePage">
            <span slot="totalItems">{{$t("TOTAL")}}: {{paging.total}} {{$t("_TRAVEL_AGENT.AGENT")}}</span>
          </paging>
        </div>
      </div>
    </div>
    <!-- Active agent dialog -->
    <v-dialog v-model="activeDialog" max-width="300" content-class="dialog-confirm">
      <v-card>
        <span>{{$t('_TRAVEL_AGENT.CONFIRM_ACTIVE')}}</span>
        <v-row>
          <v-col cols="6" class="btn-left-wrapper">
            <button class="main-btn btn-secondary" @click="activeDialog = false">{{$t('CLOSE')}}</button>
          </v-col>
          <v-col cols="6" class="btn-right-wrapper">
            <button
              class="main-btn btn-pmirary"
              @click="activeAgent(currentAgent)"
            >{{$t('_TRAVEL_AGENT.CONFIRM')}}</button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<style lang="scss" scoped>
#list-agent-deactive {
  .text-level {
    font-size: 12px;
    color: #808080;
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import Paging from "@/components/Utils/Paging.vue";
import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";
import { _alert } from "@/_helpers/function.js";
import { service } from "@/_services/TravelAgent/travel-agent.service.js";
import debounce from "lodash.debounce";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    paging: Paging,
    "input-text": Input
  },
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: this.$t("_TRAVEL_AGENT.NAME"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("_TRAVEL_AGENT.BUSINESS_TYPE"),
          align: "left",
          value: "type",
          width: "20%"
        },
        {
          text: this.$t("_TRAVEL_AGENT.TAX_CODE"),
          align: "left",
          value: "taxCode",
          width: "15%"
        },
        {
          text: this.$t("_TRAVEL_AGENT.LEVEL"),
          align: "left",
          value: "level",
          width: "15%"
        },
        {
          text: this.$t("_TRAVEL_AGENT.STATUS"),
          align: "center",
          value: "action",
          width: "250px"
        }
      ],
      data: [],
      paging: {
        // total: 0,
        limit: 15,
        offset: 0,
        name: "",
        lang: localStorage.getItem("systemLanguage") || "vi"
      },
      currentAgent: null,
      activeDialog: false,
      loading: true,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    search: debounce(function(value) {
      this.getAll();
    }, 300),
    // Run when start
    initialize() {
      // Call service
      this.getAll();
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Get all travel agent active
    getAll() {
      const locale = localStorage.getItem("systemLanguage") || "vi";
      this.isLoading = true;
      this.loading = true;
       const body = {
        lang: this.paging.lang,
        limit: this.paging.limit,
        name: this.paging.name,
        offset: this.paging.offset
      };
      service
        .getAllDeactive(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data.map(item => {
              let local = item.i18ns.find(itemData => itemData.lang === locale);
              if (!local && item.i18ns.length > 0) {
                local = item.i18ns[0];
              }
              item.local = local;
              return item;
            });
          }
          this.loading = false;
        })
        .finally(() => (this.isLoading = false));
    },
    // Show active dialog
    active(item) {
      this.activeDialog = true;
      this.currentAgent = item;
    },
    // Active agent
    activeAgent(agent) {
      this.activeDialog = false;
      if (!agent || !agent.id) {
        return;
      }
      this.isLoading = true;
      service
        .active(agent.id)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>